// src/components/layout/StepperFooter.jsx

import React from 'react';

const StepperFooter = ({ 
  currentStep = 1, 
  totalSteps = 8,
  onBack, 
  onNext,
  nextDisabled = false,
  backDisabled = false,
  nextLabel = "Next",
  backLabel = "Back",
  nextLoading = false,
  isDarkMode = false
}) => {

  return (
    <div className={`fixed bottom-0 left-0 right-0 z-[60] shadow-lg border-t transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-[#DBDCED]'
    }`}>
      <div className="max-w-[1200px] mx-auto px-8 py-4 flex justify-between items-center">
        {/* Step Counter */}
        <div className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-[#41425A]'}`}>
          Step {currentStep} of {totalSteps}
        </div>
        
        {/* Navigation Buttons */}
        <div className="flex gap-3">
          <button
            onClick={onBack}
            disabled={backDisabled}
            className={`flex items-center gap-2 px-5 py-2.5 border rounded-md text-sm font-medium transition-all duration-200 ${
              backDisabled 
                ? 'opacity-50 cursor-not-allowed' 
                : isDarkMode 
                  ? 'border-gray-600 bg-gray-700 text-gray-300 hover:bg-gray-600' 
                  : 'border-[#DBDCED] bg-[#F5F5FA] text-[#41425A] hover:bg-[#DBDCED] hover:text-[#100E27] hover:border-[#100E27]'
            }`}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {backLabel}
          </button>
          
          <button
            onClick={onNext}
            disabled={nextDisabled || nextLoading}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium transition-all duration-200 ${
              nextDisabled || nextLoading
                ? 'bg-gray-400 text-gray-300 cursor-not-allowed'
                : isDarkMode 
                  ? 'bg-[#7376B8] text-white hover:bg-[#5a5b75]'
                  : 'bg-[#100E27] text-white hover:bg-[#282641]'
            }`}
          >
            {nextLoading ? (
              <>
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                Loading...
              </>
            ) : (
              <>
                {nextLabel}
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepperFooter;